var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{class:{ menu: !_vm.isSubmenuList, 'menu-inline': !_vm.isSubmenuList }},_vm._l((_vm.menu),function(item,index){return _c('aside-menu-item',{key:index,attrs:{"item":item},on:{"menu-click":_vm.menuClick}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }